// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"dec6c7e2","230":"f4fe9427","490":"c181d7cb","787":"55493f23","949":"b5f47e92","974":"4dad9a5d"}[chunkId] + ".chunk.js";
};